import React from 'react';
import { useDropdownMenu } from 'react-overlays';
import PropTypes from 'prop-types';

import Text from '../../Text/Text';

const Menu = ({
  role, headerText, containerStyle, children, mainContainerStyle, mobile
}) => {
  const [props] = useDropdownMenu({
    flip: true,
    offset: [0, 10],
  });
  return (
    <div
      // eslint-disable-next-line react/jsx-props-no-spreading
      {...props}
      role={role}
    >
      <div
        className={`shadowDefault animate__animated animate__fadeIn animate__faster 
        bg-white dark:bg-background-dark rounded-[5px] w-max max-w-[calc(100vw-24px)]
        z-[1] min-w-[325px] ${containerStyle || ''}`}
        style={mobile ? {
          minWidth: 'min(250px, calc(100vw - 24px))',
          maxWidth: 'calc(100vw - 24px)'
        } : undefined}
      >
        {headerText && (
          <div className="p-[16px] border-b border-whiteHover dark:border-[#1b263b]">
            <Text text={headerText} bold textStyle="text-[14px]" />
          </div>
        )}
        <div className={`p-[16px] ${mainContainerStyle || ''}`}>
          {children}
        </div>
      </div>
    </div>
  );
};

Menu.propTypes = {
  role: PropTypes.string,
  headerText: PropTypes.string,
  containerStyle: PropTypes.string,
  mainContainerStyle: PropTypes.string,
  mobile: PropTypes.bool,
  children: PropTypes.node.isRequired,
};

Menu.defaultProps = {
  role: '',
  headerText: undefined,
  containerStyle: undefined,
  mainContainerStyle: undefined,
  mobile: false,
};

export default Menu;
